import React, {useEffect, useState} from 'react';

import {
  Container,
  Content,
  InfoList,
  InfoItem,
  InfoItemTitle,
  InfoDescription,
  InfoItemContent,
  Footer,
  LinkButtonContainer,
  HelpVideoContainer,
  HelpVideoThumb,
  VideoInfos,
  HelpVideoTitle,
  HelpVideoSubtitle,
} from './styles';

import {Titles} from '../../../../components/Interface/Typographies/Titles';
import {Icon} from '../../../../components/Interface/Typographies/Icon';
import {Button} from '../../../../components/Interface/Forms/Buttons/Button';
import {LinkButton} from '../../../../components/Interface/Forms/Buttons/LinkButton';
import {Linking, Platform} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {HelpVideo} from '../../../../components/shared/HelpVideo';
import thumbVideoIndGanhe from '../../../../assets/images/banners/thumb-indique.webp';

import {useTheme} from 'styled-components/native';
import {Keyboard, TouchableWithoutFeedback} from 'react-native';
import {Header as HeaderButton} from '../../../../components/Interface/Headers/Header';
import {useGlobal} from '../../../../context/global';
import {Loading} from '../../../../components/Interface/Loadings/Loading';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';

export function ReferAndWinUsersInfo() {
  const theme = useTheme();
  const navigation = useNavigation();
  const [showVideo, setShowVideo] = useState(false);

  const {configIndiqueGanhe} = useGlobal();

  return (
    <>
      <TouchableWithoutFeedback
        onPress={() => Platform.OS !== 'web' && Keyboard.dismiss()}
        accessible={false}>
        <Container>
          <HelpVideoContainer
            onPress={() => setShowVideo(true)}
            activeOpacity={1}>
            <HelpVideoThumb source={thumbVideoIndGanhe}>
              <HeaderButton
                icon="chevron-left"
                statusBarLight
                color={theme.colors.shape}
              />
              <VideoInfos>
                <HelpVideoTitle>Veja como indicar</HelpVideoTitle>
                <HelpVideoSubtitle>
                  Clique e aprenda a indicar
                </HelpVideoSubtitle>
              </VideoInfos>
            </HelpVideoThumb>
          </HelpVideoContainer>

          <Content>
            <Titles
              title="Regras do controle de indicados"
              subtitle="Saiba como funciona e como aumentar o seu limite de indicados."
            />

            {configIndiqueGanhe && configIndiqueGanhe.length > 0 ? (
              <InfoList>
                {configIndiqueGanhe.map((item, index) => (
                  <InfoItem key={item.limite_indicados}>
                    {index === 0 && <Icon name="user" />}
                    {index === 1 && <Icon name="user-friends" awesome5 />}
                    {index > 1 && <Icon name="users" awesome5 />}
                    <InfoItemContent>
                      <InfoItemTitle>{item.titulo}</InfoItemTitle>
                      <InfoDescription>{item.descricao}</InfoDescription>
                    </InfoItemContent>
                  </InfoItem>
                ))}
              </InfoList>
            ) : (
              <Loading />
            )}
          </Content>
          <Footer>
            <Button
              title="Preciso de ajuda"
              enabled
              onPress={() => navigation.navigate('Help')}
            />

            <LinkButtonContainer>
              <LinkButton
                action={() =>
                  Linking.openURL(
                    'https://wa.me/5561998202004?text=Ol%C3%A1%2C+preciso+de+ajuda%21',
                  )
                }
                enabled
                text="Falar com suporte"
              />
            </LinkButtonContainer>
          </Footer>
          {showVideo && (
            <HelpVideo
              onVideoEnd={() => setShowVideo(false)}
              videoURI={
                'https://d3ag5cip9ldvh3.cloudfront.net/INDIQUEGANHE.MP4'
              }
            />
          )}
        </Container>
      </TouchableWithoutFeedback>
    </>
  );
}
